import { displayDate, getNewDate, DATE_FORMAT_FULL_WITH_TIME } from 'utils/date';
import {
  isRelativeESDate,
  parseFromESToDateRange,
  parseTimeRangeToLabelDef,
} from 'utils/relativeDateTime';

/**
 * getDateFromValue
 * Parses the criteria value to moment to use for date/time picker.
 * @param { String } value: The date value.
 * @returns { Moment } The parsed date.
 */
export const getDateFromValue = (value) => {
  const date = new Date(parseFloat(value, 10));
  if (value && date) {
    return getNewDate({ date });
  }
  return null;
};

/**
 * getDateDisplayValue
 * Get the display value of a date.
 * @param { Date | String } value: The date value.
 * @returns { String } The display value of the date.
 */
export const getDateDisplayValue = (value) => {
  const isRelative = isRelativeESDate(value);

  if (isRelative) {
    const { startRange, endRange } = parseFromESToDateRange(value);
    const { label } = parseTimeRangeToLabelDef(startRange, endRange);
    return label;
  }
  return displayDate(getDateFromValue(value), DATE_FORMAT_FULL_WITH_TIME);
};

export const getMultiSelectInputDisplayValue = (values) => {
  return values.length > 0 ? `[...${values[0]}]` : '[]';
};

/**
 * getIsDateExact
 * Get if the date is an exact date in the form of epoch secs
 * @param { String } value: The date value.
 * @returns { Boolean } Whether the date is exact
 */
export const getIsDateExact = (value) => {
  if (!value) return false;

  try {
    // parses now+7d and 7d to values shorter that the orginal string (e.g now+7d parses to 7).
    // strings like 10202010202 will work which is how exact dates come back
    const numericValue = parseInt(value, 10);

    // catches NaN and if parse int fails (e.g. on empty strings)
    if (!numericValue) return false;

    // convert to string to check length now+7d != 7 after parsing so not exact date
    return numericValue.toString().length === value.length;
  } catch (err) {
    return false;
  }
};

/**
 * Generates url to a given list
 * @param { String | Number } id - list id
 * @returns { String } link to list
 */
export const getViewListLink = (id) => `/segmentation?emailListId=${id}`;
